import * as React from "react";

import classNames from "classnames";

import DocStyledText from "../BlockNodeHelpers/StyledText";

import { handleActions } from "../../../helpers/Doc/handleActions";

import { backgroundStyleFromNode } from "../../../helpers/Doc/changes";

interface DocButtonProps extends DocButtonType<InlineNode>, BlockNodeAll {
  progress?: number;
}

function DocButton(props: DocButtonProps) {
  const onClick = () => {
    if (!props.inactiveBool) {
      if (props.title === 'Continue') {
        const progressBar = document.querySelector('.progress-container');
        // Dynamically update aria-label based on current progress
        if (progressBar) {
          // Get the latest progress value from props or state
          let progress = typeof props.progress === 'number'
            ? props.progress
            : parseInt(progressBar.getAttribute('aria-valuenow') || '0', 10);
          // Update aria-valuenow to the latest value
          progressBar.setAttribute('aria-valuenow', String(progress));
          let label;
          if (progress === 0 || isNaN(progress)) {
            label = 'Not Started';
          } else if (progress === 100) {
            label = '100% of the case is completed';
          } else {
            label = `${Math.round(progress)}% of the case is completed`;
          }
          progressBar.setAttribute('aria-label', label);
        }
        // Use a dedicated live region for announcement
        let alertRegion = document.getElementById('screenreader-alert');
        if (!alertRegion) {
          alertRegion = document.createElement('div');
          alertRegion.id = 'screenreader-alert';
          alertRegion.setAttribute('aria-live', 'assertive');
          alertRegion.style.position = 'absolute';
          alertRegion.style.left = '-9999px';
          alertRegion.style.height = '1px';
          alertRegion.style.width = '1px';
          alertRegion.style.overflow = 'hidden';
          document.body.appendChild(alertRegion);
        }
        if (progressBar && alertRegion) {
          // Change text after a short delay to ensure announcement
          setTimeout(() => {
            const announceText = progressBar.getAttribute('aria-label') || 'Progress bar focused';
            alertRegion.textContent = announceText;
          }, 1000);
        }
      }
      handleActions(props.onClick, props);
    }
  };

  if(props.classes?.includes("case_summary_button")) {
    return <></>;
  }

  return (
    <div
      id={props.uid}
      data-is-node
      data-uid={props.uid}
      className={classNames("doc-button-slice", props.uid, {inactive: props.inactiveBool})}
      style={backgroundStyleFromNode(props)}
      contentEditable={false}
    >
      <button className="doc-button" onClick={onClick}>
        <DocStyledText
          uid={props.uid}
          content={props.title}
          contentKey={"title"}
          editingContext={props.editingContext}
          readOnly
          disableStyleTextEditing={props.disableStyleTextEditing}
        />
      </button>
    </div>
  );
}

export default React.memo(DocButton);
